import { CostType } from './../../../enum/CostType';
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDatepicker } from '@angular/material/datepicker';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { LookupDataServiceService } from 'src/app/services/lookup-data-service.service';
import { NavigationService } from 'src/app/services/navigation.service';
import { ProductService } from 'src/app/services/product.service';
import { AdditionalFeaturesPopupComponent } from '../additional-features-popup/additional-features-popup.component';
import { ProductCategoryType } from 'src/app/enum/ProductCategoryType';
import { RuleType } from 'src/app/enum/RuleType';
import { forkJoin } from 'rxjs';
import { ConnectionFeeType } from 'src/app/enum/ConnectionFeeType';
import { NotificationService } from 'src/app/services/notification-service';
import { EntityState } from 'src/app/enum/EntityState';
import { Editor, toHTML, Toolbar } from 'ngx-editor';
import { DatePipe } from '@angular/common';
import { MatTabChangeEvent } from '@angular/material/tabs';

@Component({
    selector: 'app-manage-product-add',
    templateUrl: './manage-product-add.component.html',
    styleUrls: ['./manage-product-add.component.scss']
})
export class ManageProductAddComponent implements OnInit, OnDestroy {
    type: any;
    form: FormGroup;
    imgform: FormGroup;
    productId = 0;
    existingImageNames: any;
    setDefaultImage: any = 0;
    prodcutvalue: any;
    selectedIndex: number;
    productlist: any = [];
    subproductlist: any = [];
    serviceproviderList: any = [];
    costTypelist: any = [];
    ProductClassificationlist: any = [];
    postingClassList: any = [];
    ItemClassList: any = [];
    connectionFeelist: any = [];
    subproductvalue: any;
    dropdownSettings: any;
    RulesproductList: any = [];
    filteredList1: any;
    filteredList2: any;
    filteredList3: any;
    filteredList4: any;
    filteredList5: any;
    filteredList6: any;
    filteredList7: any;
    filteredList8: any;

    today: Date = new Date();
    minEndDate: Date;
    isFileSelected = false;
    currentIndex: number = 0;
    slideInterval: any;
    content: any;
    fileName: any;
    file: any;
    FileExtention: any;
    selectedImageIndex: number = 0;
    @ViewChild('startDate') startDateDatePicker: MatDatepicker<Date>;
    @ViewChild('endDate') endDateDatePicker: MatDatepicker<Date>;
    RuleTypeEnum: any = RuleType


    subCategoryEnabled = false;
    searchTerm: string = '';
    serviceQueue = []
    groupedProducts: any;
    singleMessage: any;
    ConnectionFeeTypeEnum = ConnectionFeeType;
    ProductCategoryTypeEnum: any = ProductCategoryType;
    Productcosttypelist: any = []
    costTypeEnum = CostType
    productdetail: any;


    groupMessagingForm: FormGroup;
    fileNameImage: string = '';
    isValidFile: boolean = true;
    isValidfileExtension: boolean = true;
    isValidfileSize: boolean = true;
    LocalList: any[] = [];
    ProductImages: any[] = [];
    selectedimageUpload: any;
    selectedImage: any;
    isShowSlider: boolean = false;
    defaultProductImage: any;
    loadImageSlider: any[] = [];
    btnDisable: boolean = false;
    EntityStateEnum = EntityState
    deleteSelectedImageList: any[];
    AlternateLocalList: number;
    showSelectedImage: boolean = false;
    listOfProductImage: any;
    businessForm: FormGroup;
    productRoleData: any;
    editor: Editor;
    toolbarModules = {
        toolbar: [
            ['bold', 'italic'],
            ['underline', 'strike'],
            ['code-block', 'blockquote'],
            [{ 'list': 'ordered' }, { 'list': 'bullet' }],
            ['link'],
            [{ 'align': [] }]
        ]
    };
    featureform: FormGroup
    product: any;


    constructor(
        private activateroute: ActivatedRoute,
        public _formBuilder: FormBuilder,
        private LookupDataService: LookupDataServiceService,
        private navigationService: NavigationService,
        private ProductService: ProductService,
        private matdialog: MatDialog,
        private toast: NotificationService,
        private datePipe: DatePipe


    ) {
        this.activateroute.params.subscribe((params: any) => {
            debugger
            this.productId = parseInt(params.id);
            this.type = parseInt(params.type);
        });
        this.groupMessagingForm = this._formBuilder.group({
            fileNameImage: ['']
        });
        this.featureform = new FormGroup({
            feature: new FormControl(
            ),
        });
    }



    get doc(): AbstractControl {
        return this.form.get('editorContent');
    }



    ngOnDestroy(): void {
        this.editor.destroy();
    }
    ngOnInit() {
        this.editor = new Editor();

        this.loadServiceQueue()
        this.initForm();
        this.executeServiceQueue()
        // if (this.productId) {
        //     this.getProductLogoImageName();
        // }
        this.dropdownSettings = {
            singleSelection: false,
            idField: "key",
            textField: "value",
            selectAllText: "Select All",
            unSelectAllText: "UnSelect All",
            allowSearchFilter: true,
        };
        this.LoadProductLogo()

    }
    getImageName() {
        this.ProductService.getProductLogoImageName(this.productId).subscribe((response) => {
            // if (response != null) {
            //     for (let i = 0; i < response.length; i++) {
            //         if (response[i] === this.fileNameImage) {
            //             return alert('This file already exists');
            //         }
            //     }
            //     if (this.LocalList.length > 0) {
            //         for (let j = 0; j < this.LocalList.length; j++) {
            //             if (this.LocalList[j].imageName === this.fileNameImage) {
            //                 return alert('This file already exists');
            //             }
            //         }
            //     }

            //     const fileExtension = fileName.split('.').pop();
            //     if (!this.validateExtension(fileExtension)) {
            //         this.isValidfileExtension = false;
            //         alert('File format not accepted, use ".jpg" ".jpeg" ".png" formats');
            //     }

            //     const imageSize = input.size;
            //     if (imageSize > 5000000) {
            //         this.isValidfileSize = false;
            //         alert('Size should be less than 5MB');
            //     }

            //     const ValidOnFileSize = this.isValidfileSize;
            //     const FR = new FileReader();
            //     FR.onload = (e: any) => {
            //         setTimeout(() => {
            //             const img = new Image();
            //             img.src = e.target.result;

            //             const byteArray = e.target.result;
            //             let imgSrc;
            //             this.showSelectedImage = true;
            //             this.selectedimageUpload = byteArray;
            //             this.selectedImage = byteArray;
            //             imgSrc = this.removeBase64FromByteArray(byteArray);

            //             const imgName = this.fileNameImage;

            //             if (imageSize > 5000000 && !this.validateExtension(fileExtension)) {
            //                 this.ProjectImages.push({
            //                     ImageSource: imgSrc,
            //                     ImageName: imgName,
            //                     IsDefault: false,
            //                     ImgArray: byteArray,
            //                     State: this.EntityStateEnum.Added,
            //                     ImageSize: showSize,
            //                     IsSizeValid: ValidOnFileSize
            //                 });
            //             }
            //             this.showSelectedImage = false;

            //             const postData = {
            //                 Logo: byteArray,
            //                 LogoName: imgName,
            //                 ProductDetailId: this.productId,
            //                 DefaultImage: files.length === 1 ? 1 : 0
            //             };

            //             this.isShowSlider = true;
            //             this.LocalList.push({
            //                 image: postData.Logo,
            //                 isDefault: postData.DefaultImage,
            //                 imageName: postData.LogoName,
            //                 isSizeValid: true,
            //                 isDefaultImage: 0,
            //                 productLogoId: 0
            //             });

            //             this.loadImageSlider = this.LocalList;
            //             if (this.LocalList.length === 1) {
            //                 this.defaultProductImage = this.LocalList[0].image;
            //             } else if (this.LocalList.length > 1) {
            //                 this.defaultProductImage = this.LocalList[0].image;
            //             }
            //         });
            //     };
            //     FR.readAsDataURL(input);
            // }
        });
    }
    loadServiceQueue() {
        this.serviceQueue.push(this.LookupDataService.getProductCategoryType());
        this.serviceQueue.push(this.LookupDataService.getServiceProvider());
        this.serviceQueue.push(this.LookupDataService.getConnectionFee(true));
        this.serviceQueue.push(this.LookupDataService.geCostType(true));
        this.serviceQueue.push(this.LookupDataService.getProductClassification(true));
        this.serviceQueue.push(this.LookupDataService.getPostingClass());
        this.serviceQueue.push(this.LookupDataService.getItemClass());
        this.serviceQueue.push(this.LookupDataService.getRuleProducts());

    }
    executeServiceQueue() {
        forkJoin(this.serviceQueue).subscribe((serviceResponse: any[]) => {
            debugger
            this.productlist = serviceResponse[0];

            this.filteredList1 = [...this.productlist];

            this.serviceproviderList = serviceResponse[1].sort((a, b) => a.value.localeCompare(b.value));
            this.filteredList3 = [...this.serviceproviderList];

            this.connectionFeelist = serviceResponse[2];
            this.filteredList8 = [...this.connectionFeelist];

            this.costTypelist = serviceResponse[3];
            this.filteredList7 = [...this.costTypelist];

            this.ProductClassificationlist = serviceResponse[4].sort((a, b) => a.value.localeCompare(b.value));
            this.filteredList4 = [...this.ProductClassificationlist];

            this.postingClassList = serviceResponse[5].sort((a, b) => a.value.localeCompare(b.value));
            this.filteredList5 = [...this.postingClassList];

            this.ItemClassList = serviceResponse[6].sort((a, b) => a.value.localeCompare(b.value));
            this.filteredList6 = [...this.ItemClassList];


            this.RulesproductList = serviceResponse[7];
            this.RulesproductList.forEach(item => {
                item.productCategoryName = item.productSubCategory.subCategoryName;
                this.groupedProducts = this.RulesproductList.reduce((acc, product) => {
                    let category = product.productCategoryName;
                    let group = acc.find(g => g.categoryName === category);

                    if (!group) {
                        group = { categoryName: category, products: [] };
                        acc.push(group);
                    }

                    group.products.push(product);
                    return acc;
                }, []);
            });

            console.log("values--", this.groupedProducts);


            if (this.productId) {
                debugger
                this.form.get('startOnTs').clearValidators();

                this.ProductService.getProductsForEdit(this.productId).subscribe((results) => {
                    this.product = results
                    if (this.product.resellerActivate)
                        this.product.cost = this.product.resellerCost
                    this.productRoleData = results.productRule
                    this.FetchValues(this.product);
                    this.fetchBusinessValues(this.productRoleData)

                });
            }
        });
    }


    formatDate(date: Date | null): string {
        debugger
        if (!date) return '';
        const day = date.getDate().toString().padStart(2, '0');
        const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Months are 0-based
        const year = date.getFullYear();
        return `${year}-${month}-${day}`;
    }

    FetchValues(results: any) {
        debugger
        this.productdetail = results;
        this.form.patchValue({
            itemClass: parseInt(results.itemClass),
            postingClass: parseInt(results.postingClass),
            cost: results.cost,
            hcCost: results.hcCost,
            ProductCategoryType: results.productCategoryType,
            productSubCategoryId: results.productSubCategoryId,
            serviceProviderId: results.serviceProviderId,
            selectedProductTypeId: results.productPackageId,
            productClassification: results.productClassification,
            aliasName: results.aliasName,
            productName: results.productName,
            productId: results.productId,
            startOnTs: this.formatDate(new Date(results.startOnTs)),
            expiredOnTs: this.formatDate(new Date(results.expiredOnTs)),
            comments: results.comments,
            isNova: results.isNova,
            novaNetworkProd:results.novaNetworkProd

        })
        this.featureform.setValue({ feature: this.productdetail.features })

        if (results.productFeature.length > 0) {

            results.productFeature.forEach((item) => {
                if (item.featureKey == "DownloadSpeed") {
                    this.form.patchValue({
                        downloadSpeed: item.featureValue
                    })
                }
                if (item.featureKey == "UploadSpeed") {
                    this.form.patchValue({
                        uploadSpeed: item.featureValue
                    })
                }
                if (item.featureKey == "NoDeliveryCost") {
                    this.form.patchValue({
                        noDeliveryCost: (item.featureValue == "1") ? true : false
                    })
                }
                if (item.featureKey == "EftPayment") {
                    this.form.patchValue({
                        eftPayment: (item.featureValue == "1") ? true : false
                    })
                }
                if (item.featureKey === "CostType") {
                    Object.values(this.costTypeEnum).forEach((enumValue) => {
                        if (item.featureValue == enumValue) {
                            this.form.patchValue({
                                costType: enumValue
                            })
                        }
                    });
                }
            })
        }

        if (results.features != null) {
            this.singleMessage = this.productdetail.features;
        }

        this.LookupDataService.getProductSubCategory(this.form.value.ProductCategoryType).subscribe((res) => {
            this.subproductlist = res;
            this.filteredList2 = [...this.subproductlist];
        });


        if (results.productSubCategory.connectionFeeType !== this.ConnectionFeeTypeEnum.NoConnectionFee || !(this.form.value.ProductCategoryType === this.ProductCategoryTypeEnum.Fibre || this.form.value.ProductCategoryType === this.ProductCategoryTypeEnum.Wireless)) {
            this.subproductvalue = false;
        }
        else {
            debugger
            this.subproductvalue = true;
            this.form.patchValue({ Connectionfee: [] })
            if (this.form.value.serviceProviderId) {
                debugger
                this.LookupDataService.getConnectionFeeByServiceProviderId(this.form.value.serviceProviderId).subscribe((res) => {
                    debugger
                    this.connectionFeelist = res;
                    const selectedKeys = results.productConnectionFeeMapping.map(item => item.connectionFeeProductDetailId);
                    const selectedItems = this.connectionFeelist.filter(item => selectedKeys.includes(item.key));
                    this.form.patchValue({ connectionFeeId: selectedItems });
                });
            }
        }

    }

    initForm() {
        this.form = this._formBuilder.group({
            ProductCategoryType: [null, Validators.required],
            productSubCategoryId: [null, Validators.required],
            serviceProviderId: [null, Validators.required],
            productClassification: [null, Validators.required],
            aliasName: [null, Validators.required],
            productName: [null, Validators.required],
            productId: [null, Validators.required],
            cost: [null, Validators.required],
            costType: [0],
            connectionFeeId: [null],
            comments: [null,],
            noDeliveryCost: [false],
            eftPayment: [false],
            downloadSpeed: [null,],
            uploadSpeed: [null,],
            startOnTs: [null, Validators.required],
            expiredOnTs: [null,],
            postingClass: [null, Validators.required],
            itemClass: [null, Validators.required],
            hcCost: [null,],
            selectedProductTypeId: [null],
            isNova: [],
            novaNetworkProd: [],
        });

        this.imgform = this._formBuilder.group({
            img: ["",],
            defaultimgid: [0],
        });
        this.businessForm = this._formBuilder.group({
            selectedMustHaveAll: [[]],
            selectedMustHaveAnyOne: [[]],
        })
    }

    goToManageProduct() {
        this.navigationService.gotomanageproduct();

    }

    selectPrimaryProduct() {
        debugger
        this.LookupDataService.getProductSubCategory(this.form.value.ProductCategoryType).subscribe((res) => {
            this.subproductlist = res;
            this.filteredList2 = [...this.subproductlist]
            this.subCategoryEnabled = true;
        });
    }

    selectSubCategory() {
        this.ProductService.getSubCategoryById(this.form.value.productSubCategoryId).subscribe((res) => {
            if (res.connectionFeeType != this.ConnectionFeeTypeEnum.NoConnectionFee ||
                !this.form.value.ProductCategoryType == this.ProductCategoryTypeEnum.Fibre ||
                !this.form.value.ProductCategoryType == this.ProductCategoryTypeEnum.Wireless) {
                this.subproductvalue = false;
                this.form.get('connectionFeeId').clearValidators();

            }
            else {
                if (this.form.value.ProductCategoryType == this.ProductCategoryTypeEnum.Fibre || this.form.value.ProductCategoryType == this.ProductCategoryTypeEnum.Wireless)
                    this.subproductvalue = true;
                // if (this.form.value.ProductCategoryType == this.ProductCategoryTypeEnum.Fibre)
                    // this.form.get('connectionFeeId').setValidators(Validators.required);
            }
        });
    }

    selectServiceProvider() {
        debugger
        if (this.form.value.serviceProviderId) {
            this.LookupDataService.getConnectionFeeByServiceProviderId(this.form.value.serviceProviderId).subscribe((res) => {
                this.connectionFeelist = res;
                this.form.patchValue({ connectionFeeId: [], isNova: null, novaNetworkProd: null })
                if (this.form.value.serviceProviderId == 2) {
                    this.form.get('isNova').setValidators(Validators.required);
                }
                else{
                this.form.get('isNova').clearValidators();
                }
            });
        }
    }

    onStartDateChange(event: any) {
        const selectedStartDate = event.value;
        this.minEndDate = new Date(selectedStartDate);
        this.minEndDate.setDate(this.minEndDate.getDate() + 1);
    }
    novacheck(){
        if (this.form.value.isNova==false) {
            this.form.get('novaNetworkProd').setValidators(Validators.required);
        }
        else{
            this.form.get('novaNetworkProd').clearValidators();
        }
    }
    onTabChange(event: MatTabChangeEvent) {
        this.selectedIndex = event.index;

    }
    preview() {
        if (this.featureform.value.feature)
            this.matdialog.open(AdditionalFeaturesPopupComponent, {
                autoFocus: false,
                disableClose: true,
                panelClass: 'mat-dialog',
                width: "50%",
                data: {
                    title: 'showtext',
                    value: { image: this.defaultProductImage, content: this.featureform.value.feature }
                }
            });
        else
            this.toast.showError('Enter description for preview')
    }

    save() {
        debugger
        if (this.form.valid) {
            debugger
            let payload: any = {}
            let formValues = this.form.getRawValue()
            payload = { ...this.product, ...formValues }
            payload.productPackageId = formValues.selectedProductTypeId;
            payload.startOnTs = this.datePipe.transform(new Date(formValues.startOnTs), 'yyyy/MM/dd');
            if (this.form.value.expiredOnTs) {
                payload.expiredOnTs = this.datePipe.transform(new Date(formValues.expiredOnTs), 'yyyy/MM/dd');
            }

            // if (vm.setDefaultImage != 0) {
            //     vm.product.productLogoMappingId = vm.setDefaultImage;
            // }
            if (this.form.value.connectionFeeId) {
                let keysOnly = formValues.connectionFeeId.map(fee => fee.key);
                if (this.form.value.ProductCategoryType != this.ProductCategoryTypeEnum.ConnectionProduct) {
                    payload.connectionFeeId = keysOnly;
                }

                if (this.subproductvalue && this.form.value.connectionFeeId) {
                    payload.connectionFeeIds = [];
                    payload.connectionFeeIds = keysOnly;
                }
            }
            if (this.productId == 0) {
                payload.featuresHtml = this.featureform.value.feature
            }
            else {
                payload.featuresHtml = this.featureform.value.feature
            }


            // if (this.selectedIndex === 3) {
            debugger

            const uniqueRules = new Set();
            var productRule = []

            if (this.businessForm.value.selectedMustHaveAll) {
                this.businessForm.value.selectedMustHaveAll.forEach((item: any) => {
                    const rule = JSON.stringify({ RuleType: this.RuleTypeEnum.MustHaveAll, ruleProductDetailId: item });
                    if (!uniqueRules.has(rule)) {
                        uniqueRules.add(rule);
                        productRule.push(JSON.parse(rule));
                    }
                });
            }

            if (this.businessForm.value.selectedMustHaveAnyOne) {
                this.businessForm.value.selectedMustHaveAnyOne.forEach((item: any) => {
                    const rule = JSON.stringify({ RuleType: this.RuleTypeEnum.MustHaveAnyOne, ruleProductDetailId: item });
                    if (!uniqueRules.has(rule)) {
                        uniqueRules.add(rule);
                        productRule.push(JSON.parse(rule));
                    }
                });
            }
            payload.productRule = productRule
            // }
            // else {
            //     this.LookupDataService.getRuleProducts().subscribe(result => {
            //         if (result) {
            //             this.RulesproductList = result;
            //             this.RulesproductList.forEach(item => {
            //                 item.productCategoryName = item.productSubCategory.subCategoryName;
            //             });
            //             this.fetchBusinessValues()
            //         }
            //     });
            // }



            if (this.form.value.downloadSpeed && this.form.value.uploadSpeed) {

                payload.download = formValues.downloadSpeed;
                payload.upload = formValues.uploadSpeed;
            }

            if (this.form.value.downloadSpeed) {
                payload.download = formValues.downloadSpeed;
            }
            this.ProductService.saveProduct(payload).subscribe((results) => {

                this.listOfProductImage = this.LocalList;

                if (results.productCategoryType == this.ProductCategoryTypeEnum.Fibre || results.productCategoryType == this.ProductCategoryTypeEnum.Wireless) {
                    results.noDeliveryCost = null;
                    results.eftPayment = null;
                    results.costType =   null;
                }

                if ((results.download && results.upload) || (results.noDeliveryCost || results.eftPayment || results.costType) || (results.download)) {
                    var sendData: any = {};
                    if(this.productdetail!=null)
                        if (this.productdetail.productFeature.length == 0) {
                            sendData.length = 0;
                            sendData.ids = [];
                        }
                        else {
                            sendData.length = this.productdetail.productFeature.length;
                            sendData.ids = [];
                            for (var j = 0; j < this.productdetail.productFeature.length; j++) {
                                sendData.ids.push(this.productdetail.productFeature[j].id)

                            }
                        }
                    if (this.form.value.downloadSpeed && this.form.value.uploadSpeed) {
                        sendData.download = this.form.value.downloadSpeed;
                        sendData.upload = this.form.value.uploadSpeed;
                    }

                    if (this.form.value.downloadSpeed) {
                        sendData.download = this.form.value.downloadSpeed;
                    }
                    sendData.productDetailId = results.id;

                    if (this.form.value.noDeliveryCost == true) {
                        formValues.noDeliveryCost = "1";
                    }
                    else {
                        formValues.noDeliveryCost = "0";
                    }

                    if (this.form.value.eftPayment == true) {
                        formValues.eftPayment = "1"
                    }
                    else {
                        formValues.eftPayment = "0";
                    }

                    sendData.noDeliveryCost = formValues.noDeliveryCost;
                    sendData.eftPayment = formValues.eftPayment;
                    sendData.costType = formValues.costType;

                    this.ProductService.saveProductFeature(sendData).subscribe((featureResult) => {

                    })
                }

                if (this.listOfProductImage.length > 0) {
                    for (var i = 0; i < this.listOfProductImage.length; i++) {
                        this.listOfProductImage[i].productLogoId = results.id;
                    }
                    var postData: any = {};
                    postData.productImageItemViewModel = this.listOfProductImage;

                    this.ProductService.saveProductLogoList(postData).subscribe((ImageResult) => {
                        if (ImageResult != null) {
                            this.LocalList = [];
                        }
                    })

                }
                else {
                    var productLogoId = results.id;
                    this.ProductService.zeroDefaultImage(productLogoId).subscribe((item) => {
                    })
                }

                this.toast.showSuccess("saved successfully!")
                this.navigationService.gotomanageproduct()
            });
        }
        else {
            this.toast.showError('Please fill the required fields!')
        }

    }



    ///feature

    // createLink() {
    //     const url = prompt('Enter the URL');
    //     if (url) {
    //         this.execCmd('createLink', url);
    //     }
    // }
    // execCmd(command: string, value?: string) {
    //     if (command === 'createLink' && value) {
    //         document.execCommand(command, false, value);
    //     } else if (command === 'formatBlock' && value === 'pre') {
    //         // Insert <pre> block for code block formatting
    //         document.execCommand('formatBlock', false, 'pre');
    //     } else {
    //         document.execCommand(command, false, '');
    //     }
    // }

    // isActive(command: string): boolean {
    //     // Check if the command is currently active
    //     return document.queryCommandState(command);
    // }

    previewpopup(doc) {
        const defaultImage = this.loadImageSlider.find(doc => doc.isDefault === 1);
        this.matdialog.open(AdditionalFeaturesPopupComponent, {
            autoFocus: false,
            disableClose: true,
            panelClass: 'mat-dialog',
            width: "50%",
            data: {
                title: 'manage_product',
                value: doc.image
            }
        });
    }

    onImageSelect(index: number, fileName: string, image): void {
        debugger
        console.log('Selected image index:', index);
        this.selectedImageIndex = index;
        this.currentIndex = index;

        this.loadImageSlider.forEach((doc, i) => {
            doc.isDefault = (i === index) ? 1 : 0;
        });

        this.imgform.controls['defaultimgid'].setValue(this.selectedImageIndex);
        this.imgform.controls['img'].setValue(fileName);
        this.defaultProductImage = image
    }

    selectFile(): void {
        const inputElement = document.createElement('input');
        inputElement.type = 'file';
        inputElement.style.display = 'none';
        document.body.appendChild(inputElement);
        inputElement.click();
        inputElement.addEventListener('change', (event) => {
            debugger
            const files: FileList = (event.target as HTMLInputElement).files;
            if (!files || files.length === 0) {
                this.stopSlideShow();
                return;
            }
            Array.from(files).forEach((input) => {
                debugger
                const showSize = '';
                this.isValidFile = true;
                this.isValidfileExtension = true;
                this.isValidfileSize = true;
                const fileName = input.name;
                this.fileNameImage = fileName;

                debugger
                if (this.LocalList.length > 0) {
                    for (let j = 0; j < this.LocalList.length; j++) {
                        if (this.LocalList[j].imageName === this.fileNameImage) {
                            return alert('This file already exists');
                        }
                    }
                }

                const fileExtension = fileName.split('.').pop();
                if (!this.validateExtension(fileExtension)) {
                    this.isValidfileExtension = false;
                    alert('File format not accepted, use ".jpg" ".jpeg" ".png" formats');
                }

                const imageSize = input.size;
                if (imageSize > 5000000) {
                    this.isValidfileSize = false;
                    alert('Size should be less than 5MB');
                }

                const ValidOnFileSize = this.isValidfileSize;
                const FR = new FileReader();
                FR.onload = (e: any) => {
                    debugger
                    setTimeout(() => {
                        debugger
                        const img = new Image();
                        img.src = e.target.result;

                        const byteArray = e.target.result;
                        let imgSrc;
                        this.showSelectedImage = true
                        this.selectedimageUpload = byteArray;
                        this.selectedImage = byteArray;
                        imgSrc = this.removeBase64FromByteArray(byteArray);


                        const imgName = this.fileNameImage;

                        if (imageSize > 5000000 && !this.validateExtension(fileExtension)) {
                            this.ProductImages.push({
                                ImageSource: imgSrc,
                                ImageName: imgName,
                                IsDefault: false,
                                ImgArray: byteArray,
                                State: this.EntityStateEnum.Added,
                                ImageSize: showSize,
                                IsSizeValid: ValidOnFileSize
                            });
                        }

                        const postData = {
                            Logo: byteArray,
                            LogoName: imgName,
                            ProductDetailId: this.productId,
                            DefaultImage: files.length === 1 ? 1 : 0
                        };

                        this.isShowSlider = true;
                        this.LocalList.push({
                            image: postData.Logo,
                            isDefault: postData.DefaultImage,
                            imageName: postData.LogoName,
                            isSizeValid: true,
                            isDefaultImage: 0,
                            productLogoId: 0
                        });

                        this.loadImageSlider = this.LocalList;
                        if (this.LocalList.length === 1) {
                            this.defaultProductImage = this.LocalList[0].image;
                        } else if (this.LocalList.length > 1) {
                            this.defaultProductImage = this.LocalList[0].image;
                        }
                    });
                };
                FR.readAsDataURL(input);
            });

        })
    }

    fetchBusinessValues(productRule: any[]) {
        debugger
        const selectedMustHaveAll = [];
        const selectedMustHaveAnyOne = [];

        productRule.forEach(item => {
            this.RulesproductList.forEach(items => {
                if (item.ruleProductDetailId === items.id && item.ruleType === this.RuleTypeEnum.MustHaveAll) {
                    selectedMustHaveAll.push(items.id);
                }

                if (item.ruleProductDetailId === items.id && item.ruleType === this.RuleTypeEnum.MustHaveAnyOne) {
                    selectedMustHaveAnyOne.push(items.id);
                }
            });
        });

        this.businessForm.patchValue({
            selectedMustHaveAll: selectedMustHaveAll,
            selectedMustHaveAnyOne: selectedMustHaveAnyOne
        });
    }

    filteredGroupedProducts() {
        if (!this.searchTerm) {
            return this.groupedProducts;
        }

        return this.groupedProducts.map(group => ({
            categoryName: group.categoryName,
            products: group.products.filter(product =>
                product.aliasName.toLowerCase().includes(this.searchTerm.toLowerCase())
            )
        })).filter(group => group.products.length > 0); // Ensure no empty groups are shown
    }

    validateExtension(extension: string | undefined): boolean {
        const allowedExtensions = ['jpg', 'jpeg', 'png'];
        return allowedExtensions.includes(extension?.toLowerCase() || '');
    }

    removeBase64FromByteArray(byteArray: string): string {
        const remoft = byteArray.search('base64,');
        const final = byteArray.slice(0, remoft + 7);
        return byteArray.replace(final, '');
    }

    removeImage(index: number): void {
        debugger
        this.loadImageSlider.splice(index, 1); // Remove the image from loadImageSlider

        if (this.selectedImageIndex === index) {
            this.selectedImageIndex = 0; // Reset to the first image if the removed image was selected
        } else if (this.selectedImageIndex > index) {
            this.selectedImageIndex--;
        }

        // After removing, ensure the default image flag is updated in the form and loadImageSlider
        if (this.loadImageSlider.length > 0) {
            this.loadImageSlider[index].isDefault = 1; // Set the first image as default if no other is selected
        }

        // this.imgform.controls['defaultimgid'].setValue(this.selectedImageIndex); // Update the form control
    }

    nextImage(): void {
        this.currentIndex = (this.currentIndex + 1) % this.loadImageSlider.length;
    }

    previousImage(): void {
        this.currentIndex = (this.currentIndex - 1 + this.loadImageSlider.length) % this.loadImageSlider.length;
    }
    stopSlideShow(): void {
        clearInterval(this.slideInterval);
    }
    LoadProductLogo() {
        this.ProductService.loadProductLogoImages(this.productId).subscribe((imageResponse) => {
            debugger
            if (imageResponse.length > 0) {
                debugger
                // vm.loadImageSlider = {};
                for (var i = 0; i < imageResponse.length; i++) {
                    if (imageResponse[i].defaultImage == true) {
                        this.defaultProductImage = imageResponse[i].logo;
                    }
                    this.ProductImages.push({
                        productId: imageResponse[i].id,
                        image: imageResponse[i].logo,
                        isDefault: imageResponse[i].defaultImage,
                        imageName: imageResponse[i].logoName,
                        isSizeValid: true,
                        imageSize: 12000
                    });

                    this.LocalList.push({
                        productId: imageResponse[i].id,
                        image: imageResponse[i].logo,
                        isDefault: imageResponse[i].defaultImage,
                        imageName: imageResponse[i].logoName,
                        isSizeValid: true,
                        imageSize: 12000
                    })
                }
                this.loadImageSlider = this.LocalList;

            }
            else {
                this.defaultProductImage = "data:image/png;base64,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";
            }
        })
    }

}

